import React, {Component} from 'react';

import Settings from '../../../settings';
import Registry from '../../../registry';

import './styles.scss';

import Button from '../UIKit/Button';

class SoundOptions extends Component {
    constructor(props) {
        super(props);
        this.settings = new Settings();
        this.state = {
            new_tip_sound: this.settings.get('new_tip_sound'),
            pm_request_sound: this.settings.get('pm_request_sound'),
            pm_message_sound: this.settings.get('pm_message_sound'),
        };
    }

    saveSettings = () => {
        const {new_tip_sound, pm_request_sound, pm_message_sound} = this.state;
        this.settings.set("new_tip_sound", new_tip_sound);
        this.settings.set("pm_request_sound", pm_request_sound);
        this.settings.set("pm_message_sound", pm_message_sound);
        this.props.onSuccess();
    };

    render() {
        const lang = Registry.get('locale');
        const {new_tip_sound, pm_request_sound, pm_message_sound} = this.state;
        return (
            <div className='settings-tab SoundOptions'>
                <div className="options">
                    <div className='checkbox-type show-status'>
                        <input
                            name='closed'
                            type='checkbox'
                            id='pm_request'
                            checked={pm_request_sound}
                            onChange={(event) => this.setState({pm_request_sound: +event.target.checked})}
                        />
                        <label className="label-new" htmlFor='pm_request'>{lang.pm_request}</label>
                    </div>

                    <div className='checkbox-type show-private-messages'>
                        <input
                            name='closed'
                            type='checkbox'
                            id='pm_message'
                            checked={pm_message_sound}
                            onChange={(event) => this.setState({pm_message_sound: +event.target.checked})}
                        />
                        <label className="label-new" htmlFor='pm_message'>{lang.pm_message}</label>
                    </div>

                    <div className='checkbox-type show-private-messages'>
                        <input
                            name='closed'
                            type='checkbox'
                            id='tip'
                            checked={new_tip_sound}
                            onChange={(event) => this.setState({new_tip_sound: +event.target.checked})}
                        />
                        <label className="label-new" htmlFor='tip'>{lang.new_tip}</label>
                    </div>
                </div>

                <div className='bottom'>
                    <Button text={lang.apply} default onClick={this.saveSettings} />
                </div>
            </div>
        );
    }
}

export default SoundOptions;



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SoundOptions/index.js